var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.coverageIteration.COV_ESTIMATED_END_DATE)?_c('div',{staticClass:"counterList"},[_c('span',{staticClass:"intime",class:{'late':_vm.time>_vm.coverageIteration.COV_ESTIMATED_END_DATE}},[_vm._v(_vm._s(_vm._f("formatDuree")([_vm.time,_vm.coverageIteration.COV_ESTIMATED_END_DATE],_vm.$i18n,true)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }